import { render, staticRenderFns } from "./BandwidthItem.vue?vue&type=template&id=6c0be4a7&scoped=true"
import script from "./BandwidthItem.vue?vue&type=script&lang=js"
export * from "./BandwidthItem.vue?vue&type=script&lang=js"
import style0 from "./BandwidthItem.vue?vue&type=style&index=0&id=6c0be4a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0be4a7",
  null
  
)

export default component.exports